import { render, staticRenderFns } from "./yilianGl.vue?vue&type=template&id=0ac0977d&scoped=true"
import script from "./yilianGl.vue?vue&type=script&lang=js"
export * from "./yilianGl.vue?vue&type=script&lang=js"
import style0 from "./yilianGl.vue?vue&type=style&index=0&id=0ac0977d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0977d",
  null
  
)

export default component.exports